import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@iconify/react'

// antd
import { Tabs } from 'antd'

// slices
import { changeTab, profileState } from '../profile.slice'

// section
import OverviewTabSection from './overviewTab.section'
import EducationTabContent from '../education/educationTabContent'
import ExperienceTabContent from '../experience/experienceTabContent'
// import CertificatesTabContent from '../certificates/certificatesTabContent'
import ProjectsTabContent from '../projects/projectsTabContent'
import VideosTabContent from '../videos/videosTabContent'

import styles from './tab.section.module.css'

const TAB_META = [
    {
        key: 'summary',
        label: 'Overview',
        icon: 'mdi:view-dashboard-outline',
        children: <OverviewTabSection />,
    },
    {
        key: 'education',
        label: 'Education',
        icon: 'mdi:school-outline',
        children: <EducationTabContent />,
    },
    {
        key: 'experience',
        label: 'Experience',
        icon: 'mdi:briefcase-outline',
        children: <ExperienceTabContent />,
    },
    {
        key: 'projects',
        label: 'Projects',
        icon: 'mdi:folder-outline',
        children: <ProjectsTabContent />,
    },
    {
        key: 'videos',
        label: 'Videos',
        icon: 'mdi:video-outline',
        children: <VideosTabContent />,
    },
]

function TabSectionProfile() {
    const dispatch = useDispatch()

    const { defaultTab } = useSelector(profileState)

    const tabs = TAB_META.map((tab) => ({
        key: tab.key,
        label: (
            <span className={styles.tabLabel}>
                <span className={styles.tabIcon}>
                    <Icon icon={tab.icon} width={16} height={16} />
                </span>
                {tab.label}
            </span>
        ),
        children: tab.children,
    }))

    return (
        <Tabs
            defaultActiveKey={defaultTab}
            activeKey={defaultTab}
            onChange={(activeKey) => {
                dispatch(changeTab(activeKey))
            }}
            className={styles.tabsRoot}
            items={tabs}
        />
    )
}

export default TabSectionProfile
